export default {
	GET_FAVORITES: state => state.favorites,
}